import React from 'react';
import { ArrowUpRight, Sparkles, Lock } from 'lucide-react';
import { useTheme } from '../ThemeContext';
import { useScrollReveal, staggerDelay } from '../hooks/useScrollReveal';
import { useSiteContent } from '../SiteContentContext';

const icons = ['🚀', '🏗️', '☁️', '🧠'];

const TopicsSection = () => {
  const { isDark } = useTheme();
  const { content } = useSiteContent();
  const topics = content.topics || [];
  const [ref, isVisible] = useScrollReveal();

  if (topics.length === 0) return null;

  return (
    <section id="topics" className="max-w-6xl mx-auto px-6 py-20">
      <div ref={ref} className={`reveal ${isVisible ? 'revealed' : ''}`}>
        <div className="mb-10">
          <p className="font-mono-space text-[11px] font-bold text-red-600 uppercase tracking-[0.2em] mb-3">[ EXPLORE ]</p>
          <h2 className={`text-3xl md:text-4xl font-black tracking-tight ${isDark ? 'text-white' : 'text-gray-900'}`}>Topics I'm diving into</h2>
          <div className="line-draw h-[2px] mt-3 bg-red-600"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {topics.map((topic, index) => {
            if (topic.todo) return null; // Completey hide "in progress" topics

            return (
              <div key={index} className="stagger-child relative" style={staggerDelay(index)}>
                <a
                  href={topic.url}
                  className={`group rounded-2xl p-6 flex h-[240px] flex-col justify-between card-lift ${isDark ? 'bg-[#1a1a24] border border-gray-800 hover:border-red-900' : 'bg-white border border-gray-100 hover:border-red-100'}`}
                >
                  <span className="text-3xl mb-4">{icons[index] || '📌'}</span>
                  <div>
                    <h3 className={`mb-1 min-h-[96px] text-base font-bold leading-tight group-hover:text-red-600 transition-colors ${isDark ? 'text-white' : 'text-gray-900'}`}>
                      {topic.title}
                    </h3>
                    <span className={`inline-flex items-center gap-1 text-xs group-hover:text-red-500 transition-colors ${isDark ? 'text-gray-600' : 'text-gray-400'}`}>
                      Explore <ArrowUpRight size={12} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TopicsSection;
